<template>
  <div class="login_wrapper">
    <div class="container">
      <div class="box">
        <div class="login">
          <div class="header">
            <div class="title" v-if="+logintype === 1">用户登录</div>
            <div class="title" v-if="+logintype === 2"></div>
            <!-- <div class="wechat" @click="wechatLogin" v-if="+logintype === 1">
              <img src="@/assets/img/wechat.png" alt="">
            </div> -->
            <div class="phoneLogin" @click="phoneLogin" v-if="+logintype === 2">
              用户登录
            </div>
          </div>
          <div v-if="+logintype === 1">
            <div class="form login-input login-select">
              <!--<div class="row">-->
              <!--<div class="label">角色:</div>-->
              <!--<div class="value">-->
              <!--<el-select v-model="role" placeholder="请选择">-->
              <!--<el-option-->
              <!--v-for="item in options"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
              <!--</el-option>-->
              <!--</el-select>-->
              <!--</div>-->
              <!--</div>-->
              <div class="row">
                <div class="label">账号:</div>
                <div class="value">
                  <el-input
                    placeholder="请输入账号"
                    v-model.trim="model.usercode"
                    clearable
                  ></el-input>
                </div>
              </div>
              <div class="row">
                <div class="label">密码:</div>
                <div class="value">
                  <el-input
                    type="password"
                    placeholder="请输入密码"
                    v-model="model.password"
                    clearable
                  ></el-input>
                </div>
              </div>
              <div class="row">
                <div class="label">验证码:</div>
                <div class="value">
                  <el-input
                    placeholder="请输入验证码"
                    @keyup.enter.native="login"
                    v-model.trim="model.yzm"
                    clearable
                  ></el-input>
                </div>
                <div class="yzmpic">
                  <div v-html="imgyzm" @click="getYzm"></div>
                </div>
                <div @click="getYzm" class="yzmbtn"><span>换一张</span></div>
              </div>
            </div>
            <div class="btn" @click="login">
              <div>登录</div>
            </div>
            <div class="lead">
              <div>
                没有账号<span @click="$router.push({ path: '/reg' })"
                  >立即注册</span
                ><span @click="$router.push({ path: '/findCom' })"
                  >找回注册</span
                >
              </div>
              <span
                class="linkbtn"
                @click="$router.push({ path: '/forgotpwd' })"
                >忘记密码</span
              >
            </div>
          </div>
          <div class="form" v-if="+logintype === 2">
            <div class="wechat-box">
              <div class="wechat-code">
                <wxlogin></wxlogin>
              </div>
              <!-- <div class="wechat_text">
                  <span class="icon">
                    <i></i>
                  </span>
                  <span class="text">微信扫码登陆</span>
                </div> -->
            </div>
          </div>
          <!-- <div @click="dialogVisible = true">弹框</div> -->
          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
          >
            <span>请先关注公众号，绑定注册信息</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import request from "../utils/request";
import Md5 from "../assets/js/md5";
import wxlogin from "../components/wxlogin.vue";
import { saveTokens } from "../utils/token";
export default {
  name: "Login",
  data() {
    return {
      role: "",
      options: [],
      imgyzm: "",
      imgyzmToken: "",
      model: {
        usercode: "",
        password: "",
        yzm: "",
      },
      logintype: 1, //1是用户登陆，2是二维码登陆
      dialogVisible: false,
    };
  },
  components: { wxlogin },
  created() {
    this.getYzm();
    if (this.$route.query.t) {
      // request({
      //   method: 'post',
      //   url: '/token/getCache',
      //   data: {key: this.$route.query.t}
      // }).then ((res) => {
      //   if (!Object.keys(res).length > 0) {
      //     let local = window.localStorage
      //     local.clear()
      //     this.$store.commit('changeState', {'webLoginUser': ''})
      //   }
      // })
      let local = window.localStorage;
      local.clear();
      this.$store.commit("changeState", { webLoginUser: "" });
    }
    this.getSysCode();
    // let token = location.search ? location.search.substr(1).split('=')[1] : ''
    // console.log(this.$route.query.t)
  },
  methods: {
    phoneLogin() {
      this.logintype = 1;
    },
    wechatLogin() {
      this.logintype = 2;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    getYzm() {
      request({
        method: "get",
        url: "/validate/getSvgCaptcha",
        data: {},
      }).then((res) => {
        this.imgyzm = res.img;
        this.imgyzmToken = res.imgyzmToken;
      });
    },
    async getSysCode() {
      this.options = await request({
        url: "/web/web/getSysCodeList",
        method: "get",
        params: { syscode: "cositemcomtype" },
      });
    },
    async login() {
      // if (!this.role) {
      //   this.$message({
      //     message: '请选择角色！',
      //     type: "warning"
      //   })
      //   return
      // } else
      if (!this.model.usercode) {
        this.$message({
          message: "请输入用户名！",
          type: "warning",
        });
        return;
      } else if (!this.model.password) {
        this.$message({
          message: "请输入密码！",
          type: "warning",
        });
        return;
      } else if (!this.model.yzm) {
        this.$message({
          message: "请输入验证码！",
          type: "warning",
        });
        return;
      }
      let data = await request({
        url: "/web/web/login",
        method: "post",
        data: {
          usercode: this.model.usercode,
          password: Md5.md5(this.model.password),
          comtype: this.role,
          imgyzmToken: this.imgyzmToken,
          yzm: this.model.yzm,
          cosid: this.cosId,
        },
      });
      if (data && data.user) {
        delete data.user.userpassword;
        let user = data.user;
        user.comtype = user.cositemcomtype;
        user.token = data.token;
        saveTokens(data.token);
        this.$store.commit("changeState", { webLoginUser: user });
        // this.$router.push({path: '/'})
        window.location.replace(`${this.obWebUrl}mainIndex?t=${data.token}`);
      } else {
        this.getYzm();
      }
      //var tempwindow = window.open('_blank')
      //tempwindow.location = `${this.obWebUrl}mainIndex?t=${data.token}`
      // window.location = 'http://localhost:8088/'
    },
  },
  computed: {
    ...mapGetters(["obWebUrl", "cosId"]),
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1201px) {
  @import "../styles/variables.scss";
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.15s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .login_wrapper {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("../assets/img/login_bg.png");
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-black;
    overflow-y: hidden;
    .container {
      width: 1201px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: $color-black;
      padding-right: 40px;
      .box {
        border-radius: 3px;
        background-color: $color-bg-white;
        /*设计是425*/
        width: 405px;
        /*20200713*/
        margin: 10px 0;
        .login {
          display: flex;
          flex-direction: column;
          // padding: 0 30px;
          .header {
            display: flex;
            justify-content: space-between;
            margin-left: 30px;
            .title {
              font-size: $fontsize-large-xxx;
              font-weight: bold;
              padding: 35px 0 20px;
            }
            .phoneLogin {
              cursor: pointer;
              font-size: 18px;
              margin: 27px 10px 0 0;
            }
            .phoneLogin:hover {
              // text-decoration: underline
            }
            .wechat {
              cursor: pointer;
            }
          }
          .form {
            font-size: $fontsize-medium;
            /*设计图是40px 20200713*/
            // padding-bottom: 5px;
            padding: 0 30px 20px 30px;
            .row {
              display: flex;
              align-items: center;
              border-bottom: 1px solid $color-line-gray;
              /*20200713*/
              padding: 10px 0;
              /*设计图是40px 20200713*/
              margin-bottom: 15px;
              .label {
                width: 60px;
              }
              .value {
                flex: 1;
              }
              .yzmbtn {
                color: $color-orange;
                cursor: pointer;
                font-size: $fontsize-medium-s;
              }
            }
            .wechat-box {
              // display: flex;
              // justify-content: center;
              // margin:70px auto;
              .wechat-code {
                width: 300px;
                height: 400px;
                margin: 0 auto;
                // background-color: #000;
              }
              .wechat_text {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 10px;
                i {
                  display: inline-block;
                  width: 18px;
                  height: 18px;
                  background-size: 18px 18px;
                  background-image: url("../assets/img/wechatlogo.png");
                }
                .text {
                  display: inline-block;
                  margin-left: 10px;
                }
              }
            }
          }
          .btn {
            text-align: center;
            border-radius: 40px;
            background-color: $color-orange;
            padding: 16px;
            margin: 0 30px;
            font-size: $fontsize-large-x;
            color: #fff;
            cursor: pointer;
          }
          .lead {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: $fontsize-medium;
            /*设计图是padding: 30px 0 40px;*/
            padding: 20px 30px 20px 30px;
            span {
              cursor: pointer;
              color: $color-orange;
              border-bottom: 1px solid $color-orange;
            }
            & :first-child {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) and (min-width: 769px) {
  .content {
    .login_wrapper {
      overflow: hidden;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url(/img/login_bg.2079a222.png);
      .container {
        float: right;
        width: 26em;
        padding: 2em 2em;
        margin: 5em 5em;
        background: #fff;
        -moz-box-shadow: 1px 1px 7px #9c9c9c;
        -webkit-box-shadow: 1px 1px 7px #9c9c9c;
        box-shadow: 1px 1px 7px #9c9c9c;
        .box {
          margin: 30px 0;
          .login {
            .header {
              .title {
                font-size: 23px;
                font-weight: bold;
              }
            }
            .login-input {
              margin: 30px 0;
              .row {
                display: flex;
                align-items: center;
                margin: 30px 0;
                .label {
                  width: 3.3em;
                  text-align: right;
                  margin-right: 10px;
                }
                .value {
                  flex: 3;
                  .el-input {
                    .el-input__inner {
                    }
                  }
                }
                .yzmpic {
                }
                .yzmbtn {
                  color: #f46722;
                  font-size: 0.3em;
                }
              }
            }
            .btn {
              text-align: center;
              background-color: #f46722;
              height: 2.6em;
              line-height: 2.6em;
              border-radius: 18px;
              margin: 30px 0;
              color: #fff;
            }
            .lead {
              font-size: 13px;
              display: flex;
              justify-content: space-between;
              margin: 10px 2px;
              span {
                color: #f46722;
                border-bottom: 1px solid #f46722;
                padding: 0 5px;
              }
              .linkbtn {
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .content {
    .login_wrapper {
      margin: 10px 10px;
      .container {
        padding: 1em 1em;
        border-radius: 5px;
        background: #fff;
        -moz-box-shadow: 1px 1px 7px #9c9c9c;
        -webkit-box-shadow: 1px 1px 7px #9c9c9c;
        box-shadow: 1px 1px 7px #9c9c9c;
        .box {
          margin: 30px 0;
          .login {
            .header {
              .title {
                font-size: 23px;
                font-weight: bold;
              }
            }
            .login-input {
              margin: 30px 0;
              .row {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin: 30px 0;
                .label {
                  width: 3.3em;
                  text-align: right;
                  margin-right: 10px;
                }
                .value {
                  flex: 3;
                  .el-input {
                    .el-input__inner {
                    }
                  }
                }
                .yzmpic {
                }
                .yzmbtn {
                  color: #f46722;
                  font-size: 0.3em;
                }
              }
            }
            .btn {
              text-align: center;
              background-color: #f46722;
              height: 2.6em;
              line-height: 2.6em;
              border-radius: 18px;
              margin: 30px 0;
              color: #fff;
            }
            .lead {
              font-size: 13px;
              display: flex;
              justify-content: space-between;
              margin: 10px 2px;
              span {
                color: #f46722;
                border-bottom: 1px solid #f46722;
                padding: 0 5px;
              }
              .linkbtn {
              }
            }
          }
        }
      }
    }
  }
}
</style>